import { select2RequiredSchema, stringRequiredSchema, stringValidation } from "utils/validation/validationHelpers";
import { object } from 'yup';

const validationSchema = (descriptionLength) => {
    return object().shape({
        program_id: select2RequiredSchema,
        description: stringRequiredSchema,
    })
};

export default validationSchema;